import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import { useState } from 'react'
import { Card, CardBody } from 'reactstrap'

function JobCandidate() {
  const [showModal, setShowModal] = useState()

  const columns = [
    { headerName: 'No', field: 'no' },
    { headerName: 'Name', field: 'name', sortable: true, unSortIcon: true },
    {
      headerName: 'Category',
      field: 'category',
      sortable: true,
      unSortIcon: true,
    },
    { headerName: 'Email', field: 'email', sortable: true, unSortIcon: true },
    { headerName: 'Gender', field: 'gender', sortable: true, unSortIcon: true },

    {
      headerName: 'Country',
      field: 'country',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'State',
      field: 'state',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'City',
      field: 'city',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Profile',
      field: 'profile',
      sortable: true,
      unSortIcon: true,
    },
    { headerName: 'Resume', field: 'resume', sortable: true, unSortIcon: true },
    { headerName: 'Show Resume', field: 'showResume' },
    { headerName: 'Action', field: 'action' },
  ]

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  const rows = []

  return (
    <>
      <Card
        onClick={() => setShowModal(true)}
        className='bg-info text-white plus-button'
      >
        <FontAwesomeIcon icon={faPlus} className='' />
      </Card>
      <Card>
        <CardBody>
          <div
            className='ag-theme-alpine'
            style={{ height: '600px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={rows}
              defaultColDef={defaultColDef}
            />
          </div>
        </CardBody>
      </Card>
      {/* {showModal && (
        <CreateJobScreening showModal={showModal} setShowModal={setShowModal} />
      )} */}
    </>
  )
}

export default JobCandidate
